import AutomationCommon from "../common";
import AutomationBlockTypes from "../../AutomationBlockTypes";

const vt = AutomationCommon.vt;
const contexts = AutomationCommon.contexts;
const ga = AutomationCommon.ga;

class AICallAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate(prefix, block) {
        if (block.type !== AutomationBlockTypes.AI_CALL) {
            console.warn(`AICallAttributeFactory not supported for ${block.type}`);
            return [];
        }

        return [
            ga(contexts.BLOCK, `${prefix}.$..*`, "*", vt.OBJECT),
            ga(contexts.BLOCK, `${prefix}.success`, "Başarılı mı?", vt.BOOLEAN),
            ga(contexts.BLOCK, `${prefix}.error`, "Hata Mesajı", vt.STRING),
            ga(contexts.BLOCK, `${prefix}.call`, "Çağrı Bilgileri", vt.OBJECT, undefined, [
                ga(contexts.BLOCK, `${prefix}.call.call_id`, "Çağrı ID", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.call_status`, "Çağrı Durumu", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.call_duration`, "Çağrı Süresi (sn)", vt.NUMBER),
                ga(contexts.BLOCK, `${prefix}.call.from_number`, "Arayan Numara", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.to_number`, "Aranan Numara", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.agent_id`, "Agent ID", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.agent_name`, "Agent Adı", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.agent_voice_id`, "Agent Ses ID", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.recording_url`, "Kayıt URL", vt.STRING),
                ga(contexts.BLOCK, `${prefix}.call.call_transcript`, "Çağrı Transkripti", vt.ARRAY_OBJECT, undefined, [
                    ga(contexts.BLOCK, `${prefix}.call.call_transcript.$..role`, "Rol", vt.STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_transcript.$..content`, "Konuşma Metni", vt.STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_transcript.$..timestamp`, "Zaman", vt.NUMBER)
                ]),
                ga(contexts.BLOCK, `${prefix}.call.call_analysis`, "Çağrı Analizi", vt.OBJECT, undefined, [
                    ga(contexts.BLOCK, `${prefix}.call.call_analysis.summary`, "Özet", vt.STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_analysis.topics`, "Konular", vt.ARRAY_STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_analysis.sentiment`, "Duygu Analizi", vt.STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_analysis.action_items`, "Aksiyon Maddeleri", vt.ARRAY_STRING),
                    ga(contexts.BLOCK, `${prefix}.call.call_analysis.entities`, "Varlıklar", vt.ARRAY_OBJECT, undefined, [
                        ga(contexts.BLOCK, `${prefix}.call.call_analysis.entities.$..name`, "Varlık Adı", vt.STRING),
                        ga(contexts.BLOCK, `${prefix}.call.call_analysis.entities.$..type`, "Varlık Tipi", vt.STRING)
                    ])
                ]),
                ga(contexts.BLOCK, `${prefix}.call.dynamicVariables`, "Dinamik Değişkenler", vt.OBJECT, undefined, [
                    ga(contexts.BLOCK, `${prefix}.call.dynamicVariables.$..*`, "*", vt.MIXED)
                ]),
                ga(contexts.BLOCK, `${prefix}.call.create_time`, "Oluşturulma Zamanı", vt.DATETIME),
                ga(contexts.BLOCK, `${prefix}.call.start_time`, "Başlama Zamanı", vt.DATETIME),
                ga(contexts.BLOCK, `${prefix}.call.end_time`, "Bitiş Zamanı", vt.DATETIME)
            ])
        ];
    }
}

export default AICallAttributeFactory; 